import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * usePesquisaClienteListaFilters
 */

type State = {
  preencher: boolean;
  centroCustos: number[] | null;
  status: number;
  clientes: number[] | null;
  pesquisaCliente: string | null;
};

type Actions = {
};

export const usePesquisaClienteListaFilters = create<State & Actions>((set) => ({
  preencher: false,
  centroCustos: null,
  status: 2,
  clientes: null,
  pesquisaCliente: null,
}));

export const initializePesquisaClienteListaState: State = {
  preencher: false,
  centroCustos: null,
  status: 2,
  clientes: null,
  pesquisaCliente: null,
};